module.exports = __webpack_public_path__ + "media/Images/SuccessfulCommitmentsCount-985cff40.svg";